module.exports = {"140930100":"西口镇","140930101":"楼子营镇","140930102":"刘家塔镇","140930103":"巡镇镇","140930104":"旧县镇","140930105":"沙泉镇","140930200":"鹿固乡","140930202":"单寨乡","140930203":"土沟乡","140930205":"沙坪乡","140930206":"社梁乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140930.json
// module id = 444
// module chunks = 0